import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogujratcab() {



  const cardData =
  {
    keyword: 'Mumbai to Gujarat Cab',
    heading: 'Shambhu Cabs: Mumbai to Gujarat Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Gujarat Cab services, providing safe, comfortable, and hassle-free long-distance travel for families, corporate travelers, business groups, and tourists visiting various cities across Gujarat. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Gujarat with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes intercity travel convenient, stress-free, and dependable. For comfort, safety, and a trusted Mumbai to Gujarat cab experience, Shambhu Cabs is your reliable travel partner.',

    top: 'Top Places to Visit in Gujarat with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Somnath Temple",
    "description": "Somnath Temple, located on the Arabian Sea coast, is one of the twelve Jyotirlinga shrines dedicated to Lord Shiva. The temple showcases intricate Chalukya-style architecture with beautifully carved pillars, domes, and a golden spire. It has been rebuilt multiple times after invasions and holds immense religious significance, attracting thousands of devotees and tourists every year. The serene seashore setting enhances the spiritual ambiance."
  },
  {
    "title": "Gir National Park",
    "description": "Gir National Park is the sole natural habitat of the Asiatic lion and a major wildlife sanctuary in Gujarat. Spread across vast forested areas, the park offers safari tours, bird watching, and nature trails. Visitors can witness lions, leopards, striped hyenas, and diverse flora and fauna. It’s a paradise for wildlife enthusiasts and nature photographers seeking adventure and ecological experiences."
  },
  {
    "title": "Rani ki Vav (Patan)",
    "description": "Rani ki Vav is an intricately designed stepwell located in Patan and recognized as a UNESCO World Heritage Site. Built during the 11th century, it features seven levels of beautifully carved sculptures depicting gods, goddesses, and mythological scenes. The stepwell combines architectural brilliance with historical significance, providing visitors with a glimpse into Gujarat’s ancient engineering and artistry."
  },
  {
    "title": "Kankaria Lake (Ahmedabad)",
    "description": "Kankaria Lake is a scenic man-made lake in Ahmedabad offering boating, a zoo, amusement park, toy train rides, and food stalls. Surrounded by landscaped gardens and walking paths, it is a popular spot for families and tourists to relax and enjoy recreational activities. Evening lighting and cultural events make it a vibrant urban attraction."
  },
  {
    "title": "Dwarkadhish Temple",
    "description": "Dwarkadhish Temple, located in Dwarka, is a sacred pilgrimage site dedicated to Lord Krishna. The five-story temple showcases intricate carvings, spires, and a gold-plated flag atop its main tower. Pilgrims from across India visit to offer prayers, witness the evening aarti, and explore the spiritual heritage of this ancient city. The temple town also offers serene coastal views."
  },
  {
    "title": "Saputara Hill Station",
    "description": "Saputara, Gujarat’s only hill station, is nestled in the Western Ghats offering lush green hills, pleasant climate, and scenic viewpoints. Attractions include Saputara Lake, Sunset and Sunrise Points, Ropeway rides, Step Garden, Rose Garden, and cultural experiences at Artist Village. It is ideal for nature lovers, families, and adventure enthusiasts seeking a cool and tranquil getaway."
  },
  {
    "title": "Sun Temple (Modhera)",
    "description": "The Sun Temple in Modhera, built in the 11th century, is an architectural marvel dedicated to the Sun God. The temple complex features a richly carved main shrine, intricate stepwell (Kunda), and ornamental pillars. Its unique orientation allows the first rays of the sun to illuminate the sanctum during equinoxes. It is a must-visit for history buffs and photography enthusiasts."
  },
  {
    "title": "Lothal",
    "description": "Lothal is an important archaeological site of the ancient Indus Valley Civilization. It features a dockyard, bead-making workshops, and residential structures dating back to 2400 BCE. Visitors can explore the museum, learn about ancient trade practices, and observe excavated artifacts. Lothal offers insights into India’s early urban planning and maritime history."
  },
  {
    "title": "Vadodara (Baroda) Palace and Museums",
    "description": "Vadodara is known for the Laxmi Vilas Palace, a grand residence of the Gaekwad dynasty showcasing Indo-Saracenic architecture. The city also hosts museums like Baroda Museum and Picture Gallery, featuring historical artifacts, artworks, and cultural exhibits. Vadodara offers a blend of royal heritage, architectural splendor, and cultural richness."
  },
  {
    "title": "Bhuj and Kutch",
    "description": "Bhuj, in the Kutch region, is famous for its white salt deserts, traditional handicrafts, and cultural fairs like the Rann Utsav. Visitors can explore Bhujodi, Aina Mahal, Prag Mahal, and nearby villages. The vibrant art, folk music, and unique landscapes make it an ideal destination for travelers seeking culture, history, and natural beauty."
  }
],




"services": [
  {
    "name": "Mumbai Gujarat Taxi",
    "description": "Reliable Mumbai Gujarat Taxi services providing comfortable travel across major cities in Gujarat."
  },
  {
    "name": "Mumbai to Ahmedabad Cab",
    "description": "Mumbai to Ahmedabad Cab offers safe and convenient travel between Mumbai and Ahmedabad."
  },
  {
    "name": "Mumbai to Surat Cab",
    "description": "Mumbai to Surat Cab ensures hassle-free transportation for business or leisure trips."
  },
  {
    "name": "Mumbai to Vadodara Cab",
    "description": "Mumbai to Vadodara Cab provides punctual and comfortable travel across the distance."
  },
  {
    "name": "Mumbai to Rajkot Cab",
    "description": "Mumbai to Rajkot Cab offers long-distance travel with reliable and experienced drivers."
  },
  {
    "name": "One Way Cab Mumbai Gujarat",
    "description": "One Way Cab Mumbai Gujarat is perfect for single-direction journeys at affordable fares."
  },
  {
    "name": "Affordable Cab Mumbai Gujarat",
    "description": "Affordable Cab Mumbai Gujarat ensures budget-friendly travel without compromising safety or comfort."
  },
  {
    "name": "SUV Cab Mumbai Gujarat",
    "description": "SUV Cab Mumbai Gujarat offers spacious rides suitable for families and groups."
  },
  {
    "name": "Sedan Taxi Mumbai Gujarat",
    "description": "Sedan Taxi Mumbai Gujarat provides comfortable and economical travel for solo travelers or small groups."
  },
  {
    "name": "Corporate Cab Mumbai Gujarat",
    "description": "Corporate Cab Mumbai Gujarat caters to business travelers seeking punctual and professional transport."
  },
  {
    "name": "24x7 Cab Mumbai Gujarat",
    "description": "24x7 Cab Mumbai Gujarat ensures round-the-clock availability for early morning or late-night departures."
  },
  {
    "name": "Safe Cab Mumbai Gujarat",
    "description": "Safe Cab Mumbai Gujarat prioritizes passenger safety with well-maintained vehicles and trained drivers."
  },
  {
    "name": "Premium Cab Mumbai Gujarat",
    "description": "Premium Cab Mumbai Gujarat offers luxury vehicles for a stylish and comfortable ride."
  },
  {
    "name": "Business Cab Mumbai Gujarat",
    "description": "Business Cab Mumbai Gujarat provides efficient travel solutions for corporate and professional trips."
  },
  {
    "name": "Long Route Taxi Mumbai Gujarat",
    "description": "Long Route Taxi Mumbai Gujarat ensures optimized routes for smooth long-distance travel."
  },
  {
    "name": "Fast Taxi Mumbai Gujarat",
    "description": "Fast Taxi Mumbai Gujarat guarantees timely travel with experienced drivers and optimized routes."
  }
],

"tableData": [
  ["Mumbai Gujarat Taxi", "Mumbai to Ahmedabad Cab"],
  ["Mumbai to Surat Cab", "Mumbai to Vadodara Cab"],
  ["Mumbai to Rajkot Cab", "One Way Cab Mumbai Gujarat"],
  ["Affordable Cab Mumbai Gujarat", "SUV Cab Mumbai Gujarat"],
  ["Sedan Taxi Mumbai Gujarat", "Corporate Cab Mumbai Gujarat"],
  ["24x7 Cab Mumbai Gujarat", "Safe Cab Mumbai Gujarat"],
  ["Premium Cab Mumbai Gujarat", "Business Cab Mumbai Gujarat"],
  ["Long Route Taxi Mumbai Gujarat", "Fast Taxi Mumbai Gujarat"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Gujarat Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai to Gujarat cab services, perfect for long-distance travel, business trips, family journeys, and comfortable interstate travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to ensure a smooth and comfortable journey from Mumbai to Gujarat."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with Mumbai to Gujarat routes, ensuring safe driving, timely arrivals, and a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included in your Mumbai to Gujarat cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route guidance, and any travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans tailored to your Mumbai to Gujarat journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Gujarat journey smooth, comfortable, and worry-free."
  }
]

































  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Gujarat?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services from Mumbai to Gujarat, ensuring a smooth and safe journey to various destinations in Gujarat, including Ahmedabad, Surat, Vadodara, and more.',
  },
  {
    question: 'How can I book a cab from Mumbai to Gujarat?',
    answer: 'You can easily book a cab from Mumbai to Gujarat via our website, mobile app, or by contacting our 24x7 customer support team for a seamless booking experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Gujarat cab bookings?',
    answer: 'Shambhu Cabs offers a wide range of vehicles for your journey from Mumbai to Gujarat, including sedans, SUVs, luxury cars, and Tempo Travellers for family or group trips.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Gujarat journey?',
    answer: 'Yes, our drivers are experienced, licensed, and familiar with the routes to various destinations in Gujarat, ensuring a safe and comfortable trip.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Gujarat trip?',
    answer: 'Yes, you can choose your preferred pickup and drop-off points in Mumbai and Gujarat, providing you with a personalized and flexible travel experience.',
  },
  {
    question: 'Is the Mumbai to Gujarat cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs provides 24x7 service for your journey from Mumbai to Gujarat, allowing you to travel at any time that fits your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Gujarat trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow strict safety and hygiene measures to ensure your safety and well-being during the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Gujarat cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for all Mumbai to Gujarat cab bookings.',
  },
  {
    question: 'Is customer support available during my Mumbai to Gujarat trip?',
    answer: 'Yes, Shambhu Cabs offers 24x7 customer support to assist you throughout your journey from Mumbai to Gujarat.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patel',
    feedback: 'Our journey from Mumbai to Gujarat was very comfortable with Shambhu Cabs. The driver was courteous, the car was in excellent condition, and the service was prompt and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Desai',
    feedback: 'Shambhu Cabs made our trip from Mumbai to Gujarat very smooth and enjoyable. The driver was knowledgeable, and the car was comfortable. I highly recommend their services for long-distance travel.',
    rating: 5,
  },
];


















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const mumbaiGujaratCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Gujarat Cab",
  "serviceType": "Outstation Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-gujarat-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Gujarat cab services. Book affordable, SUV, sedan, and premium cabs for one-way, corporate, business, or family travel, available 24×7.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "890",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-gujarat-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, Gujarat, India" }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Gujarat Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Gujarat cab services with Shambhu Cabs. Affordable SUV, sedan, and premium cabs for one-way, corporate, business, or family travel, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Gujarat Taxi, Mumbai to Ahmedabad Cab, Mumbai to Surat Cab, Mumbai to Vadodara Cab, Mumbai to Rajkot Cab, One Way Cab Mumbai Gujarat, Affordable Cab Mumbai Gujarat, SUV Cab Mumbai Gujarat, Sedan Taxi Mumbai Gujarat, Corporate Cab Mumbai Gujarat, 24x7 Cab Mumbai Gujarat, Safe Cab Mumbai Gujarat, Premium Cab Mumbai Gujarat, Business Cab Mumbai Gujarat, Long Route Taxi Mumbai Gujarat, Fast Taxi Mumbai Gujarat"
  />

  <script type="application/ld+json">
    {JSON.stringify(mumbaiGujaratCabSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/70.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitogujratcab;